import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-wellness-card',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './wellness-card.component.html',
  styleUrl: './wellness-card.component.scss',
})
export class WellnessCardComponent {
  @Input() spaInfo!: any;
}
